// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__2l9_K","row":"Table_row__30TBh","cell":"Table_cell__1K5lw","rowHeader":"Table_rowHeader__3evD9"};